import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import React from 'react';
import cipher31Image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/31/image1.webp';
import cipher31Image2 from '../../../../assets/images/games/zdar-escape-game/ciphers/31/image2.webp';

type Props = {
    label?: string;
};
export default function ZdarBirdsCipher({ label }: Props) {
    return (
        <React.Fragment>
            <div className="zdar-birds-cipher">
                <div className="zdar-cipher-text-wrapper">
                    <div className="zdar-cipher--label">{label}</div>
                    <div className="zdar-cipher-text">
                        Do tajenky níže vyplňte jména ptáků, které vidíte na obrázcích. Některé ptáky jste potkali po
                        cestě a pokud jste si zapisovali kódy v průběhu hry, může vám to pomoct při hádání.
                    </div>
                </div>
                <div className="cipher-wrapper zdar-cipher-pathfinder">
                    {[cipher31Image2, cipher31Image1].map((image, i) => {
                        return (
                            <div key={i} className="cipher-image">
                                <ImageWrapper src={image} alt="cipher" shouldScroll={true} allowLightbox={false} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </React.Fragment>
    );
}
